import React, { useState, useEffect } from 'react';
import { Container, Button } from '@zoomzoomtour/zds'; // 예시 UI 라이브러리 import

function App() {
  const [timer, setTime] = useState<number>(60);

  function extractRedirectUrl(url: string | null) {
    if (!url) {
      return 'www.zoomzoomtour.com';
    }
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get('redirect') || 'www.zoomzoomtour.com';

    } catch (error) {
      return 'www.zoomzoomtour.com';
    }
  }
  const redirect = () => {
    const redirectUrl = extractRedirectUrl(window.location.href);
    window.location.replace(`https://${redirectUrl}`);
  }
  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTimer) => {
        if (prevTimer === 1) {
          clearInterval(interval);
          redirect();
          return prevTimer;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={'maintenance-wrapper'}>
      <Container sm={true}>
        <div className={'maintenance-box'}>
          <h1>서버 업데이트 및 점검중입니다.</h1>
          <div className={'content'}>
            <p>
              <b>서버 업데이트 안내</b>
            </p>
            1. 작업사유 : 서버 점검및 업데이트 <br />
            2. 작업시간 : 2025년 6월 3일 오전 09:00 ~ 오전 10:30 (한국시간 기준)
          </div>
          <ul className={'contact'}>
            <li>
              <Button
                variant={'fill-light'}
                color={'info'}
                fullWidth={false}
                onClick={() => {
                  window.open('https://90no3.channel.io/');
                }}
              >
                <b>채팅상담 바로가기</b>
              </Button>
              <br/><br/>
            </li>
            <li>이메일(고객) :
              <a href={'mailto:support@zoomzoomtour.com'} target={'_blank'}>support@zoomzoomtour.com</a>
            </li>
            <li>이메일(파트너) :
              <a href={'mailto:partners@zoomzoomtour.com'} target={'_blank'}>partners@zoomzoomtour.com</a></li>
          </ul>
          <br/>
          <Button
            variant={'fill'}
            color={'secondary'}
            fullWidth={true}
            onClick={() => redirect()}
          >
            새로고침 ({timer})
          </Button>
        </div>
      </Container>
    </div>
  );
}

export default App;
